import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
  indicator: {
    backgroundColor: theme.palette.primary.main,
  },
}));
